console.log('CES Testimonials Slider Infinite Loaded');

function initCesTestimonialsSlider(section) {
  const track = section.querySelector('.ces-testimonials__track');
  const nextBtn = section.querySelector('.ces-slider-btn--next');
  const prevBtn = section.querySelector('.ces-slider-btn--prev');

  if (!track || !nextBtn || !prevBtn) return;

  let cards = Array.from(track.children);
  if (cards.length === 0) return;

  const gap = 24;
  const cardWidth = cards[0].offsetWidth + gap;
  const total = cards.length;

  // 🔁 Clonar tarjetas para loop infinito
  cards.forEach(card => {
    const cloneEnd = card.cloneNode(true);
    cloneEnd.classList.add('clone');
    track.appendChild(cloneEnd);

    const cloneStart = card.cloneNode(true);
    cloneStart.classList.add('clone');
    track.insertBefore(cloneStart, track.firstChild);
  });

  // actualizar lista de cards
  cards = Array.from(track.children);

  let index = total; // empezamos en el primer card real
  track.scrollLeft = cardWidth * index;

  function moveTo(i, smooth = true) {
    track.style.scrollBehavior = smooth ? 'smooth' : 'auto';
    track.scrollLeft = cardWidth * i;
  }

  nextBtn.addEventListener('click', () => {
    index++;
    moveTo(index);
    if (index === total * 2) {
      setTimeout(() => {
        index = total;
        moveTo(index, false);
      }, 350); // mismo delay que smooth
    }
  });

  prevBtn.addEventListener('click', () => {
    index--;
    moveTo(index);
    if (index === total - 1) {
      setTimeout(() => {
        index = total * 2 - 1;
        moveTo(index, false);
      }, 350);
    }
  });

  // opcional: autoplay cada 5s
  // setInterval(() => nextBtn.click(), 5000);
}

/* FRONTEND */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ces-testimonials').forEach(initCesTestimonialsSlider);
});

/* SHOPIFY EDITOR */
document.addEventListener('shopify:section:load', e => {
  const section = e.target.querySelector('.ces-testimonials');
  if (section) initCesTestimonialsSlider(section);
});
